export default "__VITE_ASSET__a74bc801__"